import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';

interface Language {
  language_name?: string;
  language?: string;
  proficiency?: string;
  reading_rating?: number;
  writing_rating?: number;
  speaking_rating?: number;
}

interface ProfileLanguagesProps {
  languages?: Language[];
}

export default function ProfileLanguages({ languages }: ProfileLanguagesProps) {
  if (!languages || languages.length === 0) return null;

  const formatLanguageLabel = (lang: Language): string => {
    if (typeof lang === 'string') return lang;
    
    const name = lang.language_name || lang.language || 'Unknown';
    
    if (lang.proficiency) {
      return `${name} - ${lang.proficiency}`;
    }
    
    if (lang.reading_rating || lang.writing_rating || lang.speaking_rating) {
      const ratings = [];
      if (lang.reading_rating) ratings.push(`R:${lang.reading_rating}/5`);
      if (lang.writing_rating) ratings.push(`W:${lang.writing_rating}/5`);
      if (lang.speaking_rating) ratings.push(`S:${lang.speaking_rating}/5`);
      return `${name} (${ratings.join(', ')})`;
    }
    
    return name;
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Languages
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {languages.map((lang: any, index: number) => (
            <Chip
              key={index}
              label={formatLanguageLabel(lang)}
              variant="outlined"
              color="secondary"
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}